<template>
  <div class="field pt-2 category-attributes-config-wrap" :style="field.style" v-if="condition">
    <label class="label mb-3">
      {{ local_value.label }}
      <span class="subtitle has-text-grey-dark is-size-7 ml-2">(Renditja dhe fushet e detyrueshme)</span>
    </label>
    <div class="category-attributes-config">
      <div class="add-row">
        <div class="select is-small add-select">
          <select v-model="selectedToAdd">
            <option :value="null">Shto atribut...</option>
            <option v-for="opt in availableToAdd" :key="opt.id" :value="opt.id">{{ opt.label || opt.name }}</option>
          </select>
        </div>
        <button type="button" class="button is-small is-link add-btn" :disabled="!selectedToAdd" @click="addAttribute">
          <i class="fa fa-plus mr-1"></i> Shto
        </button>
      </div>
      <div class="attributes-list">
        <div
          v-for="(item, index) in sortedItems"
          :key="item.attribute_id"
          class="attr-row"
        >
          <div class="attr-row-order">
            <a href="#" class="order-btn" @click.prevent="move(index, -1)" :title="'Lart'" :class="{ disabled: index === 0 }">
              <i class="fa fa-chevron-up"></i>
            </a>
            <a href="#" class="order-btn" @click.prevent="move(index, 1)" :title="'Poshtë'" :class="{ disabled: index === sortedItems.length - 1 }">
              <i class="fa fa-chevron-down"></i>
            </a>
          </div>
          <span class="attr-row-num">{{ index + 1 }}</span>
          <span class="attr-row-name">{{ item.name }}</span>
          <div class="attr-row-type">
            <div class="select is-small">
              <select v-model="item.input_type_override" @change="emitSync">
                <option :value="null">
                  {{ defaultTypeLabel(item) }}
                </option>
                <option v-for="opt in inputTypeOptions" :key="opt.value" :value="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </div>
          </div>
          <AttributeUnitPicker
            class="attr-row-unit-picker"
            :measuring-unit="item.measuring_unit"
            :default-measuring-unit="item.default_measuring_unit"
            :measuring-unit-name="item.measuring_unit_name || ''"
            :units="unitOptions"
            :defer-save="true"
            @update:measuringUnit="onItemMeasuringUnit(item, $event)"
            @units-changed="onUnitsChanged"
          />
          <div class="attr-row-required">
            <label class="checkbox">
              <input type="checkbox" v-model="item.is_required" @change="emitSync" />
              <span>E detyrueshme</span>
            </label>
          </div>
          <div class="attr-row-etikete">
            <label class="checkbox">
              <input type="checkbox" v-model="item.is_label" @change="onLabelToggle(item)" />
              <span>Etiketë</span>
            </label>
            <label
              v-if="item.is_label"
              class="checkbox"
              title="Përdoret si Specifika 1 në rregullin e titullit të etiketës"
            >
              <input type="checkbox" :checked="!!item.for_label_title" @change="onForLabelTitleToggle(item, $event)" />
              <span>Titull Etikete</span>
            </label>
            <div v-if="item.is_label" class="attr-row-label-order">
              <span class="is-size-7 has-text-grey">Rend. etiketë:</span>
              <a href="#" class="order-btn" @click.prevent="moveLabel(item.attribute_id, -1)" :title="'Lart'" :class="{ disabled: labelOrderIndex(item.attribute_id) === 0 }">
                <i class="fa fa-chevron-up"></i>
              </a>
              <span class="attr-row-num">{{ labelOrderIndex(item.attribute_id) + 1 }}</span>
              <a href="#" class="order-btn" @click.prevent="moveLabel(item.attribute_id, 1)" :title="'Poshtë'" :class="{ disabled: labelOrderIndex(item.attribute_id) === labelItems.length - 1 }">
                <i class="fa fa-chevron-down"></i>
              </a>
            </div>
          </div>
          <div class="attr-row-flag">
            <label class="checkbox">
              <input type="checkbox" v-model="item.show_in_web" @change="emitSync" />
              <span>Web</span>
            </label>
          </div>
          <div class="attr-row-flag">
            <label class="checkbox">
              <input type="checkbox" v-model="item.show_in_web_as_filter" @change="emitSync" />
              <span>Filter</span>
            </label>
          </div>
          <a href="#" class="attr-row-remove" @click.prevent="remove(item.attribute_id)" title="Hiq nga kategoria">
            <i class="fa fa-times"></i>
          </a>
        </div>
        <p v-if="sortedItems.length === 0" class="empty-state">
          Asnjë atribut i zgjedhur. Zgjidhni nga lista "Shto atribut" dhe klikoni Shto.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import UnitsServices from "@/services/Unit";
import AttributeUnitPicker from "./AttributeUnitPicker.vue";

export default {
  components: { AttributeUnitPicker },
  props: ["field", "fields"],
  data() {
    return {
      local_value: null,
      selectedToAdd: null,
      inputTypeOptions: [
        { value: "text", label: "Tekst" },
        { value: "textarea", label: "Tekst i gjatë" },
        { value: "checkbox", label: "Checkbox" },
        { value: "select", label: "Lista (select)" },
        { value: "multiselect", label: "Lista (multiselect)" },
      ],
      unitOptions: [],
    };
  },
  computed: {
    condition() {
      return true;
    },
    items() {
      if (!this.local_value || !Array.isArray(this.local_value.value)) return [];
      return this.local_value.value.slice();
    },
    sortedItems() {
      return this.items
        .slice()
        .sort(
          (a, b) =>
            (a.web_sort_nr ?? a.sort_nr ?? 0) - (b.web_sort_nr ?? b.sort_nr ?? 0)
        );
    },
    labelItems() {
      return this.items
        .filter((x) => !!x.is_label)
        .slice()
        .sort((a, b) => (a.sort_nr_label ?? a.sort_nr ?? 0) - (b.sort_nr_label ?? b.sort_nr ?? 0));
    },
    availableToAdd() {
      const assigned = (this.local_value?.value || []).map((x) => x.attribute_id);
      const options = this.local_value?.options || [];
      return options.filter((o) => !assigned.includes(o.id));
    },
  },
  watch: {
    field: {
      immediate: true,
      handler(f) {
        this.local_value = f ? { ...f } : null;
      },
    },
  },
  methods: {
    defaultTypeLabel(item) {
      const base = item?.default_input_type || item?.type || null;
      if (!base) return "Tipi default";
      const map = {
        text: "Tekst",
        textarea: "Tekst i gjatë",
        checkbox: "Checkbox",
        select: "Lista (select)",
        multiselect: "Lista (multiselect)",
      };
      const human = map[base] || base;
      return `Tipi default (${human})`;
    },
    addAttribute() {
      if (!this.selectedToAdd) return;
      const opt = (this.local_value?.options || []).find((o) => o.id === this.selectedToAdd);
      const name = opt?.label || opt?.name || this.selectedToAdd;
      const current = this.local_value.value || [];
      const maxSort = current.reduce(
        (max, x) => Math.max(max, x.web_sort_nr ?? x.sort_nr ?? -1),
        -1
      );
      const nextSort = maxSort + 1;
      const value = current;
      this.local_value.value = [
        ...value,
        {
          attribute_id: this.selectedToAdd,
          name,
          is_required: false,
          is_label: false,
          for_label_title: false,
          sort_nr: nextSort,
          sort_nr_label: nextSort,
          web_sort_nr: nextSort,
          show_in_web: false,
          show_in_web_as_filter: false,
          measuring_unit: null,
          default_measuring_unit: opt?.measuring_unit ?? null,
          input_type_override: null,
        },
      ];
      this.selectedToAdd = null;
      this.emitSync();
    },
    onLabelToggle(item) {
      if (item.is_label && (item.sort_nr_label == null || item.sort_nr_label === undefined)) {
        const maxLabel = this.labelItems.reduce((max, x) => Math.max(max, x.sort_nr_label ?? x.sort_nr ?? -1), -1);
        item.sort_nr_label = maxLabel + 1;
      }
      if (!item.is_label) {
        item.for_label_title = false;
      }
      this.emitSync();
    },
    onForLabelTitleToggle(item, event) {
      const checked = !!(event?.target?.checked);
      const value = (this.local_value.value || []).map((x) => ({
        ...x,
        for_label_title: x.attribute_id === item.attribute_id ? checked : false,
      }));
      this.local_value.value = value;
      this.emitSync();
    },
    labelOrderIndex(attributeId) {
      return this.labelItems.findIndex((x) => x.attribute_id === attributeId);
    },
    moveLabel(attributeId, delta) {
      const sorted = this.labelItems;
      const index = sorted.findIndex((x) => x.attribute_id === attributeId);
      const newIndex = index + delta;
      if (index < 0 || newIndex < 0 || newIndex >= sorted.length) return;
      const item = sorted[index];
      const swap = sorted[newIndex];
      const value = this.local_value.value || [];
      const out = value.slice();
      const i = out.findIndex((x) => x.attribute_id === item.attribute_id);
      const j = out.findIndex((x) => x.attribute_id === swap.attribute_id);
      if (i === -1 || j === -1) return;
      const si = out[i].sort_nr_label ?? out[i].sort_nr ?? 0;
      const sj = out[j].sort_nr_label ?? out[j].sort_nr ?? 0;
      out[i] = { ...out[i], sort_nr_label: sj };
      out[j] = { ...out[j], sort_nr_label: si };
      this.local_value.value = out;
      this.emitSync();
    },
    remove(attributeId) {
      this.local_value.value = (this.local_value.value || []).filter((x) => x.attribute_id !== attributeId);
      this.emitSync();
    },
    move(index, delta) {
      const sorted = this.sortedItems;
      const newIndex = index + delta;
      if (newIndex < 0 || newIndex >= sorted.length) return;
      const item = sorted[index];
      const swap = sorted[newIndex];
      const value = this.local_value.value || [];
      const update = (arr) => {
        const out = arr.slice();
        const i = out.findIndex((x) => x.attribute_id === item.attribute_id);
        const j = out.findIndex((x) => x.attribute_id === swap.attribute_id);
        if (i === -1 || j === -1) return arr;
        const si = out[i].web_sort_nr ?? out[i].sort_nr ?? 0;
        const sj = out[j].web_sort_nr ?? out[j].sort_nr ?? 0;
        out[i] = { ...out[i], web_sort_nr: sj, sort_nr: sj };
        out[j] = { ...out[j], web_sort_nr: si, sort_nr: si };
        return out;
      };
      this.local_value.value = update(value);
      this.emitSync();
    },
    onItemMeasuringUnit(item, unitId) {
      item.measuring_unit = unitId;
      this.emitSync();
    },
    onUnitsChanged(units) {
      this.unitOptions = units.map((u) => ({
        id: u.id,
        label: u.name || u.label,
        name: u.name || u.label,
      }));
    },
    emitSync() {
      const value = this.local_value.value || [];
      const withSort = value.map((item, i) => ({
        ...item,
        sort_nr: item.sort_nr ?? i,
        sort_nr_label: item.sort_nr_label ?? item.sort_nr ?? i,
        web_sort_nr: item.web_sort_nr ?? item.sort_nr ?? i,
        is_label: !!item.is_label,
        for_label_title: !!item.is_label && !!item.for_label_title,
        show_in_web: !!item.show_in_web,
        show_in_web_as_filter: !!item.show_in_web_as_filter,
      }));
      this.local_value.value = withSort;
      this.$emit("syncField", { ...this.local_value });
    },
  },
  async created() {
    try {
      // Same loader as product attributes — keeps id/name/label in sync for the picker
      this.unitOptions = await UnitsServices.getUnits();
    } catch (e) {
      this.unitOptions = [];
    }
  },
};
</script>

<style scoped>
.category-attributes-config-wrap .label {
  margin-bottom: 0.5rem;
}
.category-attributes-config .add-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.category-attributes-config .add-select {
  min-width: 200px;
}
.category-attributes-config .add-btn:not(:disabled):hover {
  opacity: 0.9;
}
.category-attributes-config .add-btn:disabled {
  opacity: 0.5;
}
.attributes-list {
  max-height: 320px;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  background: #fafafa;
}
.attr-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.75rem;
  padding: 0.6rem 0.75rem;
  background: #fff;
  border-bottom: 1px solid #eee;
  min-height: 48px;
}
.attr-row:last-child {
  border-bottom: none;
}
.attr-row:hover {
  background: #f8f9fa;
}
.attr-row-order {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.attr-row-order .order-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 14px;
  color: #666;
  font-size: 0.7rem;
  line-height: 1;
}
.attr-row-order .order-btn:hover:not(.disabled) {
  color: #363636;
}
.attr-row-order .order-btn.disabled {
  opacity: 0.35;
  cursor: not-allowed;
  pointer-events: none;
}
.attr-row-num {
  min-width: 1.5rem;
  font-weight: 600;
  color: #666;
  font-size: 0.9rem;
}
.attr-row-name {
  flex: 1 1 8rem;
  min-width: 7rem;
  font-size: 0.95rem;
  color: #363636;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.attr-row-type {
  flex-shrink: 0;
}
.attr-row-unit-picker {
  flex-shrink: 0;
}
.attr-row-required,
.attr-row-flag,
.attr-row-etikete {
  flex-shrink: 0;
}
.attr-row-etikete {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.attr-row-label-order {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
}
.attr-row-required .checkbox,
.attr-row-flag .checkbox,
.attr-row-etikete .checkbox {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0;
  font-size: 0.85rem;
  white-space: nowrap;
}
.attr-row-required input[type="checkbox"],
.attr-row-flag input[type="checkbox"],
.attr-row-etikete input[type="checkbox"] {
  margin: 0;
}
.attr-row-remove {
  flex-shrink: 0;
  color: #b94a48;
  padding: 0.25rem;
  border-radius: 4px;
  opacity: 0.8;
}
.attr-row-remove:hover {
  opacity: 1;
  background: #fee2e2;
}
.empty-state {
  margin: 0;
  padding: 1.25rem 0.75rem;
  font-size: 0.9rem;
  color: #666;
  font-style: italic;
  text-align: center;
}
</style>
